const isHttps =
  typeof window !== 'undefined' &&
  window.location?.protocol === 'https:';

export function setCookie(name, value, days = 30) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const attrs = [
    'path=/',
    `expires=${expires}`,
    'SameSite=Lax',
    isHttps ? 'Secure' : null,
  ]
    .filter(Boolean)
    .join('; ');
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
    value
  )}; ${attrs}`;
}

export function getCookie(name) {
  const key = `${encodeURIComponent(name)}=`;
  return (
    document.cookie
      .split(';')
      .map((c) => c.trim())
      .reduce((acc, c) => {
        if (acc) return acc;
        return c.startsWith(key)
          ? decodeURIComponent(c.slice(key.length))
          : '';
      }, '') || null
  );
}

export function deleteCookie(name) {
  const base = `${encodeURIComponent(
    name
  )}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
  document.cookie = isHttps ? `${base}; Secure` : base;
}

export function slugify(str = '') {
  return String(str)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}
